import { RootState } from 'store';

const BudgetServices = (state: RootState) => state.supportAtHome.budgetServices;

export const selectBudgetServices = (state: RootState) => BudgetServices(state).rows;
export const selectBudgetServicesLoading = (state: RootState) => BudgetServices(state).loading;
export const selectBudgetServicesTotal = (state: RootState) => BudgetServices(state).total;
export const selectBudgetServicesCount = (state: RootState) => BudgetServices(state).count;
